<template>
    <div class="page-wrapper  margin-left-sm flex ">
        <div class="bg-white radius-lg padding flex-sub">
            <div class="flex align-center justify-between">
                <div class="classify text-xl text-black">组织机构内人员参与项目情况</div>
                <div class="search-container small flex align-center">
                    <div class="flex align-center">
                        <el-input  v-model="member_keyword" placeholder="请输入姓名" style="width: 130px"></el-input>
                        <el-button class="search-submit" type="primary" @click="member_search">搜索</el-button>
                        <el-button class="btn small bg-blue radius" type="primary" @click="expertMember">导出</el-button>
                    </div>
                </div>
            </div>
            <div class="page-list flex flex-direction margin-top-sm">
                <el-table
                    v-loading="member_loading"
                    :data="member_lists"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%">
                    <el-table-column label="姓名" prop="name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="申报项目次数" prop="name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.ex_project_num }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="参与项目次数" prop="name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.join_project_num }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="完成任务次数" prop="name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.finish_task_num }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="member_page"
                    :page-size="limit"
                    :total="member_total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next"
                    @current-change="getMembersData">
                </el-pagination>
            </div>
        </div>
        <div class="bg-white radius-lg padding margin-left-sm" style="width: 50%">
            <div class="flex align-center justify-between">
                <div class="classify text-xl text-black">参与项目人员姓名</div>
                <div class="search-container small flex align-center">
                    <div class="flex align-center">
                        <el-select v-model="cate" clearable placeholder="项目类别">
                            <el-option
                                v-for="item in classifys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-input class="margin-left-xs"  v-model="keyword" placeholder="请输入姓名" style="width: 130px"></el-input>
                        <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
                        <el-button class="btn small bg-blue radius" type="primary" @click="expertJoinMember">导出</el-button>
                    </div>
                </div>
            </div>
            <div class="page-list flex flex-direction flex-sub margin-top-sm">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%">
                    <el-table-column label="姓名" prop="name">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="参与项目次数" prop="jion_num">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.jion_num }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next"
                    @current-change="getJoinMembersData">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>


import {getMembersData, getProjectCateList, getProjectMembersData} from "@/api";
import {baseURL} from "@/config";

export default {
    name: "statistics",
    components: {},
    data() {
        return {
            classifys: [],
            member_keyword:'',
            member_lists: [],
            member_page: 1,
            member_total: 0,
            member_loading: false,

            cate:'',
            keyword:'',
            lists: [],
            page: 1,
            total: 0,
            loading: false,
            limit: 16,
        }
    },
    created() {
        this.$emit('setIndex', [6,10], '数据统计', false)
        this.getClassify()
        this.getMembersData()
        this.getJoinMembersData()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getClassify(){
            let _data = await getProjectCateList(1,1000)
            if (_data.status === 200)this.classifys = _data.data.data
        },
        async getJoinMembersData() {
            this.loading = true
            let _data = await getProjectMembersData(this.keyword,this.cate,0,this.page,this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        search(){
            this.page = 1
            this.getJoinMembersData()
        },
        expertJoinMember(){
            window.open(`${baseURL}/api/Statistics/getProjectMembersData?token=${this.user.token}&search_name=${this.member_keyword}&cate=${this.cate}&is_export=1`)
        },
        async getMembersData() {
            this.member_loading = true
            let _data = await getMembersData(this.member_keyword,0,this.member_page,this.limit)
            this.member_lists = _data.data.data
            this.member_total = _data.data.total
            this.member_loading = false
        },
        member_search(){
            this.member_page = 1
            this.getMembersData()
        },
        expertMember(){
            window.open(`${baseURL}/api/Statistics/getMembersData?token=${this.user.token}&search_name=${this.member_keyword}&is_export=1`)
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
